import { jsx as _jsx } from "react/jsx-runtime";
import { identityRecordOfFieldEditorOptions } from "@ploy-ui/form-fields";
import purifyMarked from "@ploy-lib/purify-marked";
import { makeStyles, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
const colorVariantsValues = [
    "primary",
    "secondary",
    "warning",
    "default"
]; //	"as const" to ensure validation when checking props.color
const markdownClasses = makeStyles((theme) => ({
    typographyColorVariant: (props) => ({
        color: !props.color || props.color === "default"
            ? "black"
            : props.color === "warning"
                ? "orangered"
                : theme.palette[props.color].main
    })
}));
export const MarkdownField = (props) => {
    const { field: { value: fieldValue, name }, label, form: { setFieldValue }, placeholder, hasClick } = props;
    const { formatNumber } = useIntl();
    const classes = markdownClasses(props);
    var value = fieldValue || placeholder || label;
    if (value) {
        value = value.replace(/formatCurrency{(.*?)}/, (a, b) => formatNumber(Number(b), {
            format: "currency",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }));
        value = value.replace(/formatPercent{(.*?)}/, (a, b) => formatNumber(b / 100, {
            format: "percent",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }));
    }
    return value ? (_jsx(Typography, { className: classes.typographyColorVariant, children: _jsx("div", { style: hasClick ? { cursor: "pointer" } : undefined, onClick: hasClick
                ? () => setFieldValue(name + "_click", Date.now().toString())
                : undefined, dangerouslySetInnerHTML: {
                __html: purifyMarked(value) || ""
            } }) })) : null;
};
export const EditorMarkdownFields = identityRecordOfFieldEditorOptions({
    MarkdownField: {
        editableOptions: {
            placeholder: true,
            color: colorVariantsValues
        }
    }
});
//# sourceMappingURL=MarkdownField.js.map